class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    // The drawer is only ever visible once something opened it, and whatever opened it
    // has already put the current cart in here. Loading again would overwrite that with
    // an older response — the cart as it was when the page loaded.
    if (this.loaded) return;
    this.loaded = true;

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.loaded = true;
    // Loop Order Protection assumes a Dawn-style <cart-drawer> and toggles `is-empty` on it
    // after its own /cart/clear.js (Return Portal → "Shop Now"). Our `.is-empty .mini-cart__main`
    // rule then hides every line we render until reload. The form we inject carries the real
    // empty state, so the wrapper's copy is always stale here.
    this.drawer?.classList.remove('is-empty');
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.elementId || section.id);
      if (!element) return;

      const html = parsedState.sections[section.section] || parsedState.sections[section.id];
      if (!html) return;

      const target = element.querySelector(section.selector) || element;
      target.innerHTML = this.getSectionInnerHTML(html, section.selector);
    }));

    this.open();
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];

    // An add restructures the whole cart — the transform can absorb the new item into a
    // pack already in it — so the cart page has to come back from the server too, not
    // just the drawer. Its section id is the template's, hence `elementId` alongside.
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems?.dataset.id) {
      sections.push({
        id: cartItems.dataset.id,
        section: cartItems.dataset.id,
        elementId: 'main-cart-items',
        selector: '.js-contents'
      });
    }

    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter?.dataset.id) {
      sections.push({
        id: cartFooter.dataset.id,
        section: cartFooter.dataset.id,
        elementId: 'main-cart-footer',
        selector: '.cart__footer'
      });
    }

    return sections;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
